export const environment = {
  production: true,
};
export const env = 'Dev';
export const websocketServer =
  'wss://apis.horatech.com.ar/agro-v2-websocket-dev';
export const api = 'https://apis.horatech.com.ar/agro-v2-admin-dev';
